import { X, AlertCircle, CreditCard, ArrowRight, CheckCircle } from "lucide-react";
import "./PaymentInstructionsModal.scss";
import { getLanguage } from "../../../utils/Helper";

const PaymentInstructionsModal = ({ isOpen, onClose, onProceed, depositAmount }) => {
  const lang = getLanguage();

  const content = {
    EN: {
      title: "Payment Instructions",
      subtitle: "Please read carefully before proceeding",
      steps: {
        title: "How to Complete Your Order:",
        step1: "Transfer",
        // step1b: "EGP to the following number:",
        step1b: "instapay or vodafone-cash:",
        step2: "Keep the transfer receipt (Screenshot)",
        step3: "Upload the receipt image in the checkout page",
        step4: "Your order will be reviewed within 24 hours",
        step5: "Full payment required via transfer",
      },
      phoneNumber: "01234567890",
      note: "Important Note:",
      noteText: "After completing the transfer, you'll have limited time to complete your order before the reservation expires.",
      buttons: {
        cancel: "Cancel",
        proceed: "I Understand, Continue to Checkout",
      },
      checklist: {
        title: "Before you proceed:",
        item1: "I have read the payment instructions",
        item2: "I understand I need to transfer the full amount",
        item3: "I will upload my payment receipt",
      },
    },
    AR: {
      title: "تعليمات الدفع",
      subtitle: "برجاء القراءة بعناية قبل المتابعة",
      steps: {
        title: "كيفية إتمام طلبك:",
        step1: "قم بتحويل مبلغ",
        step1b: "عن طريق فودافون كاش او إنستاباي:",
        step2: "احتفظ بإيصال التحويل (Screenshot)",
        step3: "قم برفع صورة الإيصال في صفحة الدفع",
        step4: "سيتم مراجعة طلبك خلال 24 ساعة",
        step5: "يجب دفع المبلغ كاملاً عن طريق التحويل",
      },
      phoneNumber: "01234567890",
      note: "ملحوظة مهمة:",
      noteText: "بعد إتمام التحويل، سيكون لديك وقت محدود لإكمال الطلب قبل انتهاء الحجز.",
      buttons: {
        cancel: "إلغاء",
        proceed: "فهمت، المتابعة للدفع",
      },
      checklist: {
        title: "قبل المتابعة:",
        item1: "قرأت تعليمات الدفع",
        item2: "أفهم أنني بحاجة لتحويل المبلغ كاملاً",
        item3: "سأقوم برفع إيصال الدفع",
      },
    },
  };

  const t = content[lang] || content.EN;

  const formatCurrency = (amount) => {
    if (typeof amount !== "number")
      return lang === "AR" ? "0.00 ج.م" : "EGP 0.00";
    return lang === "AR"
      ? `${amount.toFixed(2)} ج.م`
      : `EGP ${amount.toFixed(2)}`;
  };

  if (!isOpen) return null;

  return (
    <>
      {/* Overlay */}
      <div className="payment-modal-overlay" onClick={onClose} />

      {/* Modal */}
      <div className={`payment-instructions-modal ${lang === "AR" ? "rtl" : "ltr"}`}>
        <div className="modal-header">
          <div className="modal-header-content">
            <div className="modal-icon">
              <CreditCard size={32} />
            </div>
            <div>
              <h2 className="modal-title">{t.title}</h2>
              <p className="modal-subtitle">{t.subtitle}</p>
            </div>
          </div>
          <button className="modal-close-btn" onClick={onClose} aria-label="Close">
            <X size={24} />
          </button>
        </div>

        <div className="modal-body">
          {/* Payment Amount Highlight */}
          <div className="payment-amount-card">
            <div className="amount-label">Total Amount to Transfer</div>
            <div className="amount-value">{formatCurrency(depositAmount)}</div>
          </div>

          {/* Instructions */}
          <div className="instructions-section">
            <div className="instruction-header">
              <AlertCircle size={24} />
              <h3>{t.steps.title}</h3>
            </div>
            <ol className="instruction-list">
              <li>
                {t.steps.step1} <strong>{depositAmount.toFixed(2)}</strong> {t.steps.step1b}
                {/* <div className="phone-number-display">{t.phoneNumber}</div> */}
              </li>
              <li>{t.steps.step2}</li>
              <li>{t.steps.step3}</li>
              <li>{t.steps.step4}</li>
              <li className="highlight-step">{t.steps.step5}</li>
            </ol>
          </div>

          {/* Important Note */}
          <div className="important-note">
            <strong>{t.note}</strong>
            <p>{t.noteText}</p>
          </div>
        </div>

        <div className="modal-footer">
          <button className="modal-cancel-btn" onClick={onClose}>
            {t.buttons.cancel}
          </button>
          <button className="modal-proceed-btn" onClick={onProceed}>
            {t.buttons.proceed}
            <ArrowRight size={20} className={lang === "AR" ? "rotate-180" : ""} />
          </button>
        </div>
      </div>
    </>
  );
};

export default PaymentInstructionsModal;